
import React from 'react';

import { connect } from 'react-redux';

import cpdTimeFormatter from '../../services/cpdTimeFormatter';

import * as detailPageActions from '../../actions/detailPage';

import DetailPage  from '../DetailPage';
import Breadcrumbs from '../Breadcrumbs';
import PageLink    from '../PageLink';

class CourseDetailPage extends React.Component {

    _getModuleName() {

        if (this.props.model) {

            return this.props.model.module.name;
        }
    }

    _getCourseName() {

        if (this.props.model) {

            return this.props.model.name;
        }
    }

    _getOverview() {

        if (this.props.model) {

            return this.props.model.description;
        }
    }

    _getTestimonials() {

        if (this.props.model) {

            return this.props.model.testimonials;

        } else {

            return [];
        }
    }

    _getCPDHours() {

        if (this.props.model) {

            return cpdTimeFormatter.formatHours(this.props.model.cpd_hours);
        }
    }

    _getCPDMinutes() {

        if (this.props.model) {

            return cpdTimeFormatter.formatHours(this.props.model.cpd_minutes);
        }
    }

    _getUpcomingEvents() {

        if (this.props.model) {

            return this.props.model.upcoming_events;

        } else {

            return [];
        }
    }

    _getFeaturedTestimonial() {

        if (this.props.model) {

            return this.props.model.featured_testimonial;

        } else {

            return [];
        }
    }

    getModuleHexColour() {

        if (this.props.model) {

            return this.props.model.module.hex_colour;

        } else {

            return '#96afe1';
        }
    }

    _getBreadcrumbs() {

        return (
            <Breadcrumbs>
                <PageLink to="/courses">Courses</PageLink>
                <PageLink to={ `/courses/${ this.props.params.courseId }` }>{ this._getCourseName() }</PageLink>
            </Breadcrumbs>
        );
    }

    _getPromotionalDetail() {

        if(this.props.model) {

            return this.props.model.promotional_details;
        }
    }

    _getIsELearningCourse() {

        if(this.props.model) {
            return !!this.props.model.elearning_course_id;
        }
    }

    _getCourseType() {

        if (this.props.model) {
            return this.props.model.type;
        }
    }

    render() {

        return <DetailPage refreshData={ this.props.refreshData.bind(this, this.props.params.courseId) }
                           showResourcePacks={this.props.model && this.props.model.has_resource_packs}
                           courseType={this._getCourseType()}
                           moduleHexColour={ this.getModuleHexColour() }
                           pageType="course"
                           breadcrumbs={ this._getBreadcrumbs() }
                           featuredTestimonial={ this._getFeaturedTestimonial() }
                           showVenueAccordion={ false }
                           moduleName={ this._getModuleName() }
                           courseName={ this._getCourseName() }
                           courseOverview={ this._getOverview() }
                           testimonials={ this._getTestimonials() }
                           cpdHours={ this._getCPDHours() }
                           cpdMinutes={ this._getCPDMinutes() }
                           upcomingEvents={ this._getUpcomingEvents() }
                           promotionalDetails={ this._getPromotionalDetail() }
                           isELearningCourse={ this._getIsELearningCourse() }/>;
    }
}

function mapStateToProps(state) {

    return {
        ...state.detailPage,
        initialValues: {
            code: ''
        }
    };
}

function mapDispatchToProps(dispatch) {

    return {
        refreshData(courseId) {

            dispatch(detailPageActions.refreshCourse(courseId));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetailPage);


// WEBPACK FOOTER //
// ./components/CourseDetailPage/index.js